import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import EntityNameSchema, { EntityNameJSON } from "legal-entities/entity-names/_schema/entity-name-schema";
import PrimitiveValueObject from "_framework/entities/values/primitive-value-object";

export default class EntityName extends PrimitiveValueObject<EntityName, string, EntityNameJSON> {
  public static create(value: string): EntityName {
    const validated = EntityNameSchema.validate(value);
    return new EntityName(validated);
  }

  public static fromJSON(data: unknown): EntityName | null | undefined {
    if (isNullOrUndefined(data)) return data;
    const parsed = EntityNameSchema.deserialize(data);
    return new EntityName(parsed);
  }

  public constructor(public readonly value: string) {
    super(value);
    if (!value) {
      throw new InvalidEntityNameError("EntityName must have a value.");
    }
  }

  public toJSON(): EntityNameJSON {
    return EntityNameSchema.serialize(this.value);
  }

  public valueOf(): string {
    return this.value;
  }

  public isEqualTo(other: EntityName | null | undefined): boolean {
    if (!other) return false;
    return this.value === other.value;
  }

  public toString(): string {
    return `EntityName { value: ${this.value} }`;
  }
}

export class InvalidEntityNameError extends Error {}
